import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { GlobalStyles } from './GlobalStyles';
import Hero from './components/Hero';
import Sidebar from './components/Sidebar';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  
  @media (min-width: 1024px) {
    flex-direction: row;
  }
`;

const MainContent = styled(motion.main)`
  flex: 1;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  @media (min-width: 1024px) {
    padding: 4rem;
  }
`;

const SidebarContainer = styled.div`
  @media (min-width: 1024px) {
    width: 400px;
    flex-shrink: 0;
  }
`;

const BackgroundParticles = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: -1;
  
  &::before {
    content: '';
    position: absolute;
    top: 20%;
    left: 10%;
    width: 2px;
    height: 2px;
    background: #00d4ff;
    border-radius: 50%;
    box-shadow: 
      0 0 10px #00d4ff,
      100px 200px 0 #8a2be2,
      200px 50px 0 #00d4ff,
      300px 150px 0 #8a2be2,
      400px 300px 0 #00d4ff,
      500px 100px 0 #8a2be2,
      600px 250px 0 #00d4ff,
      700px 80px 0 #8a2be2,
      800px 200px 0 #00d4ff,
      900px 120px 0 #8a2be2;
    animation: twinkle 4s infinite;
  }
  
  @keyframes twinkle {
    0%, 100% { opacity: 0.3; }
    50% { opacity: 1; }
  }
`;

function App() {
  return (
    <>
      <GlobalStyles />
      <BackgroundParticles />
      <AppContainer>
        <MainContent
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <Hero />
        </MainContent>
        <SidebarContainer>
          <Sidebar />
        </SidebarContainer>
      </AppContainer>
    </>
  );
}

export default App; 